import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
/**
 * Clase para definir funciones y propiedades de forma global, es decir, para ser utilizada en las demas clases
 */
@Injectable({
  providedIn: "root",
})
export class Setting {
  /**
   * Url de la API que utiliza la aplicacion para consultar las distintas inforamciones de los widgets
   */
  APIEndPoint: string = environment.APIEndPoint;
  BaseAPIUrl: string = this.APIEndPoint;

  /**
   * Nest API
   * */

  /**
   * Endpoints pre-definidos
   */
  Endpoint = {
    Login: `${this.APIEndPoint}/auth`,
    Users: `${this.BaseAPIUrl}/user`,
    UsersWithOrganization: `${this.BaseAPIUrl}/user/with-organization`,
    UserByAccess: `${this.BaseAPIUrl}/UserByAccess`,
    Organizations: `${this.BaseAPIUrl}/organization`,
    Contacts: `${this.BaseAPIUrl}/contact`,
    EntityType: `${this.BaseAPIUrl}/entity-types`,
    ListOfValues: `${this.BaseAPIUrl}/list-of-values`,
    SystemPreferences: `${this.BaseAPIUrl}/system-preferences`,
    CustomFields: `${this.BaseAPIUrl}/custom-fields`,
    Prospects: `${this.BaseAPIUrl}/v1/Prospects`,
    CreateProspect: `${this.BaseAPIUrl}/v1/CreateProspects`,
    DelProspect: `${this.BaseAPIUrl}/v1/DelProspects`,
    FilterProspects: `${this.BaseAPIUrl}/v1/rest`,
    Views: `${this.BaseAPIUrl}/Views`,
    Roles: `${this.BaseAPIUrl}/role`,
    Access: `${this.BaseAPIUrl}/role/access`,
    RemoveRoleAccess: `${this.BaseAPIUrl}/RemoveRoleAccess`,
    RolesAccess: `${this.BaseAPIUrl}/RolesAccess`,
    UsersRoles: `${this.BaseAPIUrl}/UsersRoles`,
    RemoveUserFromRole: `${this.BaseAPIUrl}/RemoveUserFromRole`,
    getPickList: `${this.APIEndPoint}/getPickList`,
    Logs: `${this.APIEndPoint}/api/Logs`,
    LogsByCompId: `${this.APIEndPoint}/LogsByCompId`,
    LogsUsers: `${this.APIEndPoint}/LogsUsers`,
    SalesForceObj: `${this.BaseAPIUrl}/v1/getObjectData`,
    getObjectDataMultiFilter: `${this.BaseAPIUrl}/v1/getObjectDataMultiFilter`,
  };

  /**
   * Endpoints pre-definidos para la API de Nest
   * relacionados a la conversion de leads a cuentas/programas
   * */

  /**
   * Global http options
   */
  HttpOptions = {
    headers: new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded'
    }),
  };
  /**
   * TimeOut general pre-definido
   */
  GlobalTimeOut: number = 30000;
}
